<template>
  <v-layout class="grey lighten-3">
    <v-container fluid class="py-0" grid-list-md>
      <v-flex xs12 class="pa-4" v-if="lAction === 'view'">
        <v-layout row wrap>
          <v-flex xs3>
            <v-card @click="attendanceSummary()" class="teal lighten-1" style="height: 88px; margin-left: 0px;">
              <v-list-item>
                <v-sheet
                elevation="2"
                height="75"
                width="75"
                class="orange"
                style="margin-top: 6px; margin-left: -5px;">
                  <v-icon large color="white" class="pa-5">mdi-apps</v-icon>
                </v-sheet>
              </v-list-item>
              <div class="mr-5" style="margin-top: -50px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 14px; color: #ffffff"><strong>Attendance <br>Summary</br></strong></div>
            </v-card>
          </v-flex>
          <v-flex xs3>
            <v-card @click="OTReportSummary()" class="teal lighten-1" style="height: 88px; margin-left: 0px;">
              <v-list-item>
                <v-sheet
                elevation="2"
                height="75"
                width="75"
                class="orange"
                style="margin-top: 6px; margin-left: -5px;">
                  <v-icon large color="white" class="pa-5">mdi-playlist-check</v-icon>
                </v-sheet>
              </v-list-item>
              <div class="mr-5" style="margin-top: -50px; text-align:right; font-family: Roboto,sans-serif!important; font-size: 14px; color: #ffffff"><strong>Over Time <br>Report</br></strong></div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- 1.0 Attendance Report -->
      <v-flex xs12 v-if="lAction === 'attendance-report'" class="mt-2">
        <v-card>
          <v-card-title class="pa-2 primary--text grey lighten-4">
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs3>
                  <v-layout row wrap>
                    <v-btn class="pt-3" small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                    <v-flex>Attendance Summary Report</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex  xs3 class="pt-1">
                  <v-select
                  v-model="lAttRpt.comm_id"
                  label="Community"
                  :items="commList"
                  item-text="comm_name"
                  item-value="comm_id"
                  hide-details
                  clearable
                  multiple
                  outlined
                  dense
                  style="font-size: 12px"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.comm_name }}</span>
                      </v-chip>
                      <span
                        v-if="index === 1"
                        class="grey--text text-caption"
                      >
                      (+{{ lAttRpt.comm_id.length - 1 }} others)
                      </span>
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item
                      ripple
                      @click="toggle"
                      >
                        <v-list-item-action>
                          <v-icon :color="lAttRpt.comm_id && lAttRpt.comm_id.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>Select All</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs2 class="pt-5">
                  <v-dialog ref="dlgstartDt"
                  persistent v-model="dlgstartDt"
                  max-width="290px"
                  :return-value.sync="lAttRpt.from_dt">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                      slot="activator"
                      label="From Date"
                      v-model="lAttRpt.from_dt" append-icon="mdi-calendar-today"
                      :rules="[rules.required]"
                      style="font-size: 12px; margin-top: -17px;"
                      readonly
                      outlined
                      dense
                      v-on="on"
                      hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="lAttRpt.from_dt" scrollable
                    first-day-of-week="1"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text @click="dlgstartDt = false">Cancel</v-btn>
                      <v-btn text color="accent" @click="$refs.dlgstartDt.save(lAttRpt.from_dt)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs2 class="pt-0">
                  <v-card-actions>
                    <v-btn small @click="clearAttendanceReport">Clear</v-btn>
                    <v-btn small @click="searchReport" color="accent" :disabled="beingSaved">search</v-btn>
                  </v-card-actions>
                </v-flex>
                <v-flex xs2 class="text-right">
                  <v-download-as
                  :headers="attreportHeader"
                  :items="attendanceReport"
                  title="Staff List"
                  ></v-download-as>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="attreportHeader"
            :items="attendanceReport"
            fixed-header
            dense
            height="550px"
            hide-default-header
            hide-default-footer
            disable-pagination
            :mobile-breakpoint="0"
            >
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 55px; text-align: center">{{headers[0].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: left">{{headers[1].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: left">{{headers[2].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 150px; text-align: center">{{headers[3].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: left">{{headers[4].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[5].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[6].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: left">{{headers[7].text}}</th>
                  </tr>
                </thead>
              </template>
              <template slot="item" slot-scope="props">
                <tr>
                  <td class="text-center" style="font-size: 12px;">{{ props.index + 1 }}</td>
                  <td class="text-left" style="font-size: 12px;">{{ props.item.proj_name ? props.item.proj_name : '-' }}</td>
                  <td class="text-left" style="font-size: 12px;">{{ props.item.staff_role ? props.item.staff_role : '-' }}</td>
                  <td class="text-center" style="font-size: 12px;">{{ props.item.shift_abbr ? props.item.shift_abbr : '-' }}</td>
                  <td class="text-left" style="font-size: 12px;">{{ props.item.staff_name ? props.item.staff_name : '-' }}</td>
                  <td class="text-center" style="font-size: 12px;">{{ props.item.att_dt ? props.item.att_dt : '-' }}</td>
                  <td class="text-center" style="font-size: 12px;">{{ props.item.attendance ? props.item.attendance : '-' }}</td>
                  <td class="text-left" style="font-size: 12px;">{{ props.item.standby_emp_name ? props.item.standby_emp_name : '-' }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- 2.0 Over Time Report -->
      <v-flex xs12 v-if="lAction === 'ot-report'" class="mt-2">
        <v-card>
          <v-card-title class="pa-2 primary--text grey lighten-4">
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs3>
                  <v-layout row wrap>
                    <v-btn class="pt-3" small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                    <v-flex>Over Time Report</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs2 class="pt-5">
                  <v-dialog ref="dlgOTstartDt"
                  persistent v-model="dlgOTstartDt"
                  max-width="290px"
                  :return-value.sync="lOTRpt.from_dt">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                      slot="activator"
                      label="From Date"
                      v-model="lOTRpt.from_dt" append-icon="mdi-calendar-today"
                      :rules="[rules.required]"
                      style="font-size: 12px; margin-top: -17px;"
                      readonly
                      outlined
                      dense
                      v-on="on"
                      hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="lOTRpt.from_dt" scrollable
                    first-day-of-week="1"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text @click="dlgOTstartDt = false">Cancel</v-btn>
                      <v-btn text color="accent" @click="$refs.dlgOTstartDt.save(lOTRpt.from_dt)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs2 class="pt-0">
                  <v-card-actions>
                    <v-btn small @click="clearOTReport">Clear</v-btn>
                    <v-btn small @click="searchOTReport" color="accent" :disabled="beingSaved">search</v-btn>
                  </v-card-actions>
                </v-flex>
                <v-flex xs2 class="text-right">
                  <v-download-as
                  :headers="otReportHeader"
                  :items="OTReport"
                  title="Staff List"
                  ></v-download-as>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="otReportHeader"
            :items="OTReport"
            fixed-header
            dense
            height="550px"
            hide-default-header
            hide-default-footer
            disable-pagination
            :mobile-breakpoint="0"
            >
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 55px; text-align: center">{{headers[0].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: left">{{headers[1].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: left">{{headers[2].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 200px; text-align: left">{{headers[3].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[4].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 170px; text-align: center">{{headers[5].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 170px; text-align: center">{{headers[6].text}}</th>
                    <th class="uniformtableheader white--text" style="font-size: 13px; width: 120px; text-align: center">{{headers[7].text}}</th>
                  </tr>
                </thead>
              </template>
              <template slot="item" slot-scope="props">
                <tr>
                  <td class="text-center" style="font-size: 12px;">{{ props.index + 1 }}</td>
                  <td class="text-left" style="font-size: 12px;">{{ props.item.proj_name ? props.item.proj_name : '-' }}</td>
                  <td class="text-left" style="font-size: 12px;">{{ props.item.staff_name ? props.item.staff_name : '-' }}</td>
                  <td class="text-left" style="font-size: 12px;">{{ props.item.emp_desig ? props.item.emp_desig : '-' }}</td>
                  <td class="text-center" style="font-size: 12px;">{{ props.item.att_dt ? handy.formatDBDate(props.item.att_dt) : '-' }}</td>
                  <td class="text-center" style="font-size: 12px;">{{ props.item.check_in ? handy.formatDBDateTime(props.item.check_in) : '-' }}</td>
                  <td class="text-center" style="font-size: 12px;">{{ props.item.check_out ? handy.formatDBDateTime(props.item.check_out) : '-' }}</td>
                  <td class="text-center" style="font-size: 12px;">{{ props.item.effective_work_hours ? props.item.effective_work_hours : '-' }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>


      <!-- snack bar for reporting -->
      <v-snackbar :color="sbarCol" v-model="sbar"
      :timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
      </v-snackbar>

    </v-container>
  </v-layout>
</template>

<script>
import VDownloadAs from './VDownloadAs.vue'
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      lAction: 'view',
      sbarMsg: '',
      sbarCol: 'error',
      sbar: false,
      config: config,
      handy: handy,
      rules: handy.rules,
      beingSaved: false,
      attendanceReport: [],
      lAttRpt: [],
      commList: [],
      dlgstartDt: false,
      attreportHeader: [
        { text: 'Sno' , value: 'sno' },
        { text: 'Community Name' , value: 'proj_name', sortable: true },
        { text: 'Staff Role' , value: 'staff_role' },
        { text: 'Shift' , value: 'shift_abbr' },
        { text: 'Employee Name' , value: 'staff_name' },
        { text: 'Att Date' , value: 'att_dt' },
        { text: 'Attendance' , value: 'attendance' },
        { text: 'Sby Staff' , value: 'standby_emp_name' }
      ],
      dlgOTstartDt: false,
      OTReport: [],
      lOTRpt: [],
      otReportHeader: [
        { text: 'Sno' , value: 'sno' },
        { text: 'Project Name' , value: 'proj_name', sortable: true },
        { text: 'Employee Name' , value: 'staff_name' },
        { text: 'Designation' , value: 'emp_desig' },
        { text: 'Att Date' , value: 'att_dt' },
        { text: 'Check-in' , value: 'check_in' },
        { text: 'Check-out' , value: 'check_out' },
        { text: 'Work Hours' , value: 'effective_work_hours' }
      ]
    }
  },
  created () {
    this.loadCommunity()
    this.lAttRpt = this.getEmptyAttRptDet()
    var curDate = new Date()
    this.lAttRpt.from_dt = handy.formatDBDate(curDate)
    this.lOTRpt.from_dt = handy.formatDBDate(curDate)
  },
  computed: {
    selectAllComm () {
      return this.lAttRpt.comm_id.length === this.commList.length
    },
    selectSomeComm () {
      return this.lAttRpt.comm_id.length > 0 && !this.selectAllComm
    },
    icon () {
      if (this.selectAllComm) return 'mdi-close-box'
      if (this.selectSomeComm) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    attendanceSummary() {
      this.loadCommunity()
      // this.loadClosedProjectCommunity()
      this.attendanceReport = []
      this.lAction = 'attendance-report'
    },
    toggle () {
      this.$nextTick(() => {
        if (this.selectAllComm) {
          this.lAttRpt.comm_id = []
        } else {
          this.lAttRpt.comm_id = this.commList.slice()
        }
      })
    },
    getEmptyAttRptDet () {
      var emptyAttRptDet = {
        vendor_id: config.VENDOR_ID,
        comm_id: [],
        from_dt: null
      }
      return emptyAttRptDet
    },
    loadCommunity () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.commList = []
      this.axios.get(config.API_URL + '/getProjectCommList/', qry)
      .then(response => {
        this.commList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    clearAttendanceReport () {
      this.lAttRpt.comm_id = []
      this.lAttRpt.from_dt = null
      this.loadCommunity()
      this.attendanceReport = []
    },
    searchReport () {
      if (!this.lAttRpt.from_dt || this.lAttRpt.comm_id.length === 0 ) {
        this.msg('Please select Community and date', 0)
        return
      }
      var qry = {
        params: {
          comm_id_list: ''
        }
      }
      qry.params.from_dt = this.lAttRpt.from_dt
      var filterCond = 'and a.comm_id in ('
      if (this.selectAllComm) {
        this.lAttRpt.comm_id.forEach((rec, i) => {
          filterCond += rec.comm_id + ', '
        })
      } else {
        this.lAttRpt.comm_id.forEach((rec, i) => {
          filterCond += rec + ', '
        })
      }
      filterCond = filterCond.slice(0, -2) + ') '
      qry.params.comm_id_list = filterCond
      qry.params.vendor_id = config.VENDOR_ID
      this.beingSaved = true
      this.attendanceReport = []
      this.axios.get(config.API_URL + '/getConRptAttendanceReport/', qry)
      .then(response => {
        this.attendanceReport = response.data
        this.beingSaved = false
      })
      .catch(err => {
        this.beingSaved = false
        this.msg(err, 0)
      })
    },

    OTReportSummary() {
      this.OTReport = []
      this.lAction = 'ot-report'
    },
    clearOTReport() {
        this.lOTRpt.from_dt = null
        this.OTReport = []
    },

    searchOTReport () {
      if (!this.lOTRpt.from_dt ) {
        this.msg('Please select start date', 0)
        return
      }
      var qry = {
        params: {
          from_dt: this.lOTRpt.from_dt,
          vendor_id: config.VENDOR_ID
        }
      }

      this.OTReport = []
      this.axios.get(config.API_URL + '/getOTSummaryReportForLast7Days/', qry)
      .then(response => {
        this.OTReport = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },

  }
}
</script>
